import { ACCOUNT_TYPES } from "../../data/Constants";

export const selectAuth = (state) => state?.auth;
export const selectIsAuth = (state) => state?.auth?.isAuthenticated;
export const selectUser = (state) => state?.auth?.user;
export const selectToken = (state) => state?.auth?.user?.token;
export const selectEmail = (state) => state?.auth?.user?.email;
export const selectAccountType = (state) => state?.auth?.user?.account_type;
export const selectIsAdmin = (state) =>
  state?.auth?.user?.account_type === ACCOUNT_TYPES.admin;
export const selectIsGym = (state) =>
  state?.auth?.user?.account_type === ACCOUNT_TYPES.gym;
export const selectIsReceptionist = (state) =>
  state?.auth?.user?.account_type === ACCOUNT_TYPES.sales_executive;
